// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__32HqB","unreadBadge":"styles_unreadBadge__uG9EY","modalContent":"styles_modalContent__Er7ny","modal":"styles_modal__2HVnV"};